import LookUpModel from "./LookUpModel";

export default class TipoProdottoModel extends LookUpModel {
    constructor(data: Partial<TipoProdottoModel>) {
        super(data);

        this.update(data);
    }
}
